import { MessageCircle } from "lucide-react";
import { COMPANY } from "@/data/company";

export default function WhatsAppFAB() {
  return (
    <a
      href={COMPANY.whatsappLink}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1DA851] text-white pl-3 pr-4 py-3 shadow-lg rounded-full transition-colors"
      data-testid="whatsapp-fab"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="text-sm font-semibold hidden sm:inline">WhatsApp</span>
    </a>
  );
}
